import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { trackAnalyticsEvent } from '../track';
export function useMasterFilterTracking(page) {
  const $ = _c(10);
  let t0;
  if ($[0] !== page) {
    t0 = (isOpen, activeCount) => {
      trackAnalyticsEvent(isOpen ? "master_filter_opened" : "master_filter_closed", {
        page,
        active_count: activeCount
      });
    };
    $[0] = page;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onOpenChange = t0;
  let t1;
  if ($[2] !== page) {
    t1 = activeCount_0 => {
      trackAnalyticsEvent("master_filter_reset", {
        page,
        active_count: activeCount_0
      });
    };
    $[2] = page;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onReset = t1;
  let t2;
  if ($[4] !== page) {
    t2 = (name, activeCount_1) => {
      trackAnalyticsEvent("master_filter_changed", {
        page,
        filter_name: name,
        active_count: activeCount_1
      });
    };
    $[4] = page;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onFieldChange = t2;
  let t3;
  if ($[6] !== onFieldChange || $[7] !== onOpenChange || $[8] !== onReset) {
    t3 = {
      onOpenChange,
      onReset,
      onFieldChange
    };
    $[6] = onFieldChange;
    $[7] = onOpenChange;
    $[8] = onReset;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}